import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useCombinedStore } from "../store";
import { motion } from "framer-motion";

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 0.2,
};

const PrivateRoutes: React.FC = () => {
  const { authUserZustand } = useCombinedStore();
  const isAuthenticated = !!authUserZustand?.authUser;

  if (isAuthenticated) {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
      >
        <Outlet />
      </motion.div>
    );
  } else {
    return <Navigate to="/login" />;
  }
};

export default PrivateRoutes;
